var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.53125C16 2.46875 13.5312 0 10.4688 0C7.4375 0.03125 5 2.46875 5 5.5C5 6.125 5.09375 6.6875 5.25 7.25L0.21875 12.2812C0.0625 12.4375 0 12.625 0 12.8125V15.25C0 15.6875 0.3125 16 0.75 16H4.25C4.65625 16 5 15.6875 5 15.25V14H6.25C6.65625 14 7 13.6875 7 13.25V12H8.15625C8.375 12 8.5625 11.9062 8.71875 11.75L9.46875 10.9062C9.78125 10.9688 10.125 11 10.5 11C13.5312 11 16 8.5625 16 5.53125ZM10.5 4C10.5 3.1875 11.1562 2.5 12 2.5C12.8125 2.5 13.5 3.1875 13.5 4C13.5 4.84375 12.8125 5.5 12 5.5C11.1562 5.5 10.5 4.84375 10.5 4Z",
    fill: "#888888"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.8e9fc4743a30861476b12a7b078060fc.svg";
export { ForwardRef as ReactComponent };